import API_URL from "../config";
import { useNavigate } from "react-router-dom";

// Hook que devuelve la función apiFetch
export function useApiFetch() {
    const navigate = useNavigate();

    const apiFetch = async (endpoint, options = {}, logout) => {
        try {
            // Construir opciones de fetch
            const fetchOptions = {
                credentials: "include", // Mantiene cookies de sesión
                ...options,
            };


            if (fetchOptions.body && !fetchOptions.headers?.["Content-Type"]) {
                fetchOptions.headers = {
                    ...fetchOptions.headers,
                    "Content-Type": "application/json",
                };
            }

            const response = await fetch(`${API_URL}/${endpoint}`, fetchOptions);

            // Leer respuesta como texto primero
            const text = await response.text();

            let data;
            try {
                data = JSON.parse(text);
            } catch (e) {
                console.error("Respuesta no es JSON válido:", text);
                return { status: "error", message: "Respuesta inválida del servidor." };
            }

            // Detectar sesión expirada o no iniciada
            if (
                data.status === "error" &&
                (data.message?.includes("inactividad") || data.message?.includes("no iniciada"))
            ) {
                if (logout) logout();   // Limpiar estados globales
                navigate("/login");     // Redirigir al login
                return { status: "error", message: data.message };
            }

            return data;
        } catch (error) {
            console.error("Error en apiFetch:", error);
            return { status: "error", message: "Error de conexión con el servidor." };
        }
    };

    return apiFetch;
}